import { QuickStatsBox } from 'app/components/editor/subtoolbar/tags/Overview/QuickStatsBox/QuickStatsBox';
import { NewIconButton, SearchInput } from 'app/components/ui';
import { FilterDropdown, FilterGroup, FilterResults } from 'app/components/editor/sidebar/tags/TagsFilter';

import './OverviewHeader.scss';

interface OverviewHeaderProps {
  stats: { label: string; value: number; type: string }[];
  totalTags: number;
  totalMandatoryTags: number;
  searchInput: string;
  setSearchInput: (input: string) => void;
  filters: { [group: string]: string[] };
  filterGroups: FilterGroup[];
  onAddFilter: (group: string, value: string) => void;
  onRemoveFilter: (group: string, value: string) => void;
  onClose?: () => void;
}

export const OverviewHeader = ({
  stats,
  totalTags,
  totalMandatoryTags,
  searchInput,
  setSearchInput,
  onClose,
  filters,
  onAddFilter,
  filterGroups,
  onRemoveFilter,
}: OverviewHeaderProps) => {
  const includeCloseButton = !!onClose;

  return (
    <div className="overview-header">
      <div className={`overview-header__container ${includeCloseButton ? 'overview-header__container--with-close' : ''}`}>
        {stats.map((stat) => (
          <QuickStatsBox key={stat.type} {...stat} total={stat.type === 'mandatory' ? totalMandatoryTags : totalTags} />
        ))}

        {includeCloseButton && (
          <span className="overview-header__close-btn">
            <NewIconButton variant="transparent" icon="close" onClick={onClose} data-bs-dismiss="modal" aria-label="Close" />
          </span>
        )}
      </div>

      <div className={`overview-header__helpers ${includeCloseButton ? 'overview-header__helpers--with-close' : ''}`}>
        <div>
          <FilterDropdown onSelect={onAddFilter} selected={filters} groups={filterGroups} />
          <FilterResults filters={filters} onRemove={onRemoveFilter} filterGroups={filterGroups} />
        </div>
        <SearchInput searchInput={searchInput} setSearchInput={setSearchInput} />
      </div>
    </div>
  );
};
